<template>
    <div class="strategybacktestmain">
        <div class="strategyquestion">
            <div class="question_title">
                <p class="fl">请输入您想要回测的问句：&nbsp;&nbsp;</p>
                <p class="fl" ref="sentenceNotice" style="display: none">策略问句不能为空!</p>
            </div>
            <div class="question_main" :class="transactiontype === '2' ? 'minh' : ''">
                <div class="question_sentence" v-click-outside="hideSearchList">
                    <input
                        ref="question_sentence_input"
                        type="text"
                        id="question_sentence_input"
                        class="question_sentence_input"
                        placeholder="请输入问句"
                        autocomplete="off"
                        v-model="sentence"
                        @keyup="debounceQuestion($event, 1)"
                        @blur="questionDataValidation($event, 0)"
                        @keyup.enter="startBacktest"
                        v-validate="{ type: 'string', max: 200, min: 1, errClass: 'question_sentence_input focus', errRef: 'sentenceNotice'}">
                    <span @click="empty"></span>
                    <key-list
                        v-if="searchVis"
                        :list-visible.sync="searchVis"
                        :list-data="searchList"
                        :max-num="7"
                        @click-item="updateInput"
                        @select-item="updateInput"
                        @no-checked="nochecked">
                    </key-list>
                </div>
                <div class="question_section">
                    <p class="fl">选择您想回测的时间区间：&nbsp;&nbsp;</p>
                    <p class="fl" ref="numberNotice" style="display: none">请正确输入大于1的正整数，可用英文状态下&nbsp","&nbsp分隔天数!</p>
                    <p class="fl" ref="profitlossNotice" style="display: none">请输入正数!</p>
                </div>
                <div class="sd-toolbar">
                    <div class="sd-toolbar_operabox">
                        <input id="trade_detail_startDate" type="text" readonly="readonly" class="trade_detail_startDate" v-model="tradeStartDate" @click="showTradeDateDialog($event, '#F{$dp.$D(\'trade_detail_endDate\')}', '2014-1-1')" @blur="startDatePoint" @keyup.enter="startBacktest">
                        <span class="time-split">&nbsp;至&nbsp;</span>
                        <input id="trade_detail_endDate" type="text" readonly="readonly" class="trade_detail_endDate" v-model="tradeEndDate" @click="showTradeDateDialog($event, yesterdayDate, '#F{$dp.$D(\'trade_detail_startDate\')}')" @blur="endDatePoint" @keyup.enter="startBacktest">
                    </div>
                </div>
                <div class="question_model">
                    <p class="fl">填写您想使用的交易模型：&nbsp;&nbsp;</p>
                    <label>
                        <input class="icon_checkbox" type="radio" name="transaction" value="1" v-model="transactiontype" @click="commonModel">
                        <div class="checkbox_img"></div>
                        <span>普通规则交易</span>
                    </label>
                    <label>
                        <input class="icon_checkbox" type="radio" name="transaction" value="2" v-model="transactiontype" @click="marketModel">
                        <div class="checkbox_img"></div>
                        <span>市场择时交易</span>
                    </label>
                </div>
                <div class="question_model_normal" v-show="transactiontype === '1'">
                    <div class="buy_layer">
                        <span class="car"></span>
                        <div class="moment">
                            <span>时机 : </span>
                            <span>开盘买入</span>
                        </div>
                        <div class="cycle">
                            <span>持股周期 : </span>
                            <input
                                ref="question_cycle_input"
                                type="text"
                                class="question_cycle_input"
                                v-model="number"
                                @blur="qusetionCycle"
                                @keyup="validateInput"
                                @keyup.enter="startBacktest"
                                v-validate="{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice', isGt1: 1}">
                            <span>&nbsp;&nbsp;天</span>
                        </div>
                        <div class="shares">
                            <span>持股上限 : </span>
                            <select class="shares_select" v-model="stockHold" @click="sharesSelect">
                                <option :value="item" v-for="(item, index) in sharesselect" :key="index">{{ item }} 只</option>
                            </select>
                        </div>
                        <div class="shares">
                            <span>单日买入数 : </span>
                            <select class="shares_select" v-model="dayBuyStockNum">
                                <option :value="item" v-if="parseInt(item) <= parseInt(stockHold)" v-for="(item, index) in sharesselect" :key="index">{{ item }} 只</option>
                            </select>
                        </div>
                        <div class="capital">
                            <span>资金量 : </span>
                            <input
                                ref="capital_input"
                                type="text"
                                class="capital_input"
                                v-model="capital"
                                @keyup.enter="startBacktest"
                                v-validate="{ type: 'number', errClass: 'capital_input focus', errRef: 'profitlossNotice' }">
                            <span>&nbsp;&nbsp;元</span>
                        </div>
                    </div>
                    <div class="sell_layer">
                        <span class="car"></span>
                        <div class="target_profit">
                            <span>止盈 : </span>
                            <p>收益率 ≥
                                <input
                                    type="text"
                                    v-model="upperIncome"
                                    value="10"
                                    ref="upper_income"
                                    @blur="commonTargetProfitRiseRapidly"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> % 时坚定持有;直到最高收益回落
                                <input
                                    v-model="fallIncome"
                                    type="text"
                                    value="10"
                                    ref="fall_income"
                                    @blur="commonTargetProfitFall"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> %
                            </p>
                        </div>
                        <div class="stop_loss">
                            <span>止损 : </span>
                            <p>收益率 ≤ -
                                <input
                                    type="text"
                                    v-model="lowerIncome"
                                    value="10"
                                    ref="lower_income"
                                    @blur="commonStopProfit"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> %
                            </p>
                        </div>
                        <div class="position_control">
                            <span>仓位控制 : </span>
                            <span>满仓</span>
                        </div>
                    </div>
                    <div class="finish" v-show="isfinishshow">
                        <p>回测运行完成 !</p>
                    </div>
                    <div class="savebacktest" @click="save" v-show="isfinishshow">{{ isPublish === 1 ? '已发布' : '保存发布' }}</div>
                    <div v-if="!defaultqueryLoading" class="beginbacktest" @click="startBacktest">{{ isfinishshow ? '再次回测' : '开始回测'}}</div>
                </div>
                <div class="question_model_market" v-show="transactiontype === '2'">
                    <div class="buy_layer">
                        <span class="car"></span>
                        <div class="moment">
                            <span>时机 : </span>
                            <span>开盘买入</span>
                        </div>
                        <div class="cycle">
                            <span>持股周期 : </span>
                            <input
                                ref="question_cycle_input_1"
                                type="text"
                                class="question_cycle_input"
                                v-model="number"
                                @blur="qusetionCycle"
                                @keyup.enter="startBacktest"
                                v-validate="{ type: 'period', errClass: 'question_cycle_input focus', errRef: 'numberNotice', isGt1: 1}">
                            <span>&nbsp;&nbsp;天</span>
                        </div>
                        <div class="shares">
                            <span>持股上限 : </span>
                            <select class="shares_select" v-model="stockHold" @click="sharesSelect">
                                <option :value="item" v-for="(item, key, index) in sharesselect" :key="key">{{ item }} 只</option>
                            </select>
                        </div>
                        <div class="shares">
                            <span>单日买入数 : </span>
                            <select class="shares_select" v-model="dayBuyStockNum">
                                <option :value="item" v-if="parseInt(item) <= parseInt(stockHold)" v-for="(item, index) in sharesselect" :key="index">{{ item }} 只</option>
                            </select>
                        </div>
                        <div class="capital">
                            <span>资金量 : </span>
                            <input
                                ref="capital_input_1"
                                type="text"
                                class="capital_input"
                                v-model="capital"
                                @keyup.enter="startBacktest"
                                v-validate="{ type: 'number', errClass: 'capital_input focus', errRef: 'profitlossNotice' }">
                            <span>&nbsp;&nbsp;元</span>
                        </div>
                    </div>
                    <div class="market_title">
                        <p>强势市场: </p>
                    </div>
                    <div class="sell_layer_up">
                        <span class="car"></span>
                        <div class="target_profit">
                            <span>止盈 : </span>
                            <p>收益率 ≥
                                <input
                                    type="text"
                                    v-model="upperIncome"
                                    value="10"
                                    ref="upper_income_1"
                                    @blur="marketStrongTargetProfitRiseRapidly"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> % 时坚定持有;直到最高收益回落
                                <input
                                    type="text"
                                    v-model="fallIncome"
                                    value="10"
                                    ref="fall_income_1"
                                    @blur="marketStrongTargetProfitFall"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> %
                            </p>
                        </div>
                        <div class="stop_loss">
                            <span>止损 : </span>
                            <p>收益率 ≤ -
                                <input
                                    type="text"
                                    v-model="lowerIncome"
                                    value="10"
                                    ref="lower_income_1"
                                    @blur="marketStrongStopProfit"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> %
                            </p>
                        </div>
                        <div class="position_control">
                            <span>仓位控制 : </span>
                            <span>满仓</span>
                        </div>
                    </div>
                    <div class="market_title">
                        <p>弱势市场: </p>
                    </div>
                    <div class="sell_layer_down">
                        <span class="car"></span>
                        <div class="target_profit">
                            <span>止盈 : </span>
                            <p>收益率 ≥
                                <input
                                    type="text"
                                    v-model="bearMarketUpperIncome"
                                    value="10"
                                    ref="bear_market_upper_income"
                                    @blur="marketWeakTargetProfitRiseRapidly"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> % 时坚定持有;直到最高收益回落
                                <input
                                    type="text"
                                    v-model="bearMarketFallIncome"
                                    value="10"
                                    ref="bear_market_fall_income"
                                    @blur="marketWeakTargetProfitFall"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> %
                            </p>
                        </div>
                        <div class="stop_loss">
                            <span>止损 : </span>
                            <p>收益率 ≤ -
                                <input
                                    type="text"
                                    v-model="bearMarketLowerIncome"
                                    value="10"
                                    ref="bear_market_lower_income"
                                    @blur="marketWeakStopProfit"
                                    @keyup.enter="startBacktest"
                                    v-validate="{ type: 'number', errClass: ' focus', errRef: 'profitlossNotice'}"> %
                            </p>
                        </div>
                        <div class="position_control">
                            <span>仓位控制 : </span>
                            <select class="position_select" v-model="buyPosition" @click="marketWeakPositionControl">
                                <option :value="key * 10" v-for="(item, key, index) in buyPositionSelect" :key="key">{{ item }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-click-outside="closemoresignal">
                        <div class="market_title" style="width:215px;">
                            <p class="fl">市场信号: </p>
                            <span @click.stop="moresignal"></span>
                            <p class="fl" v-show="ismarketshow">请添加市场信号</p>
                        </div>
                        <div class="signalshadow" v-show="isshadowshow">
                            <ul class="firstul">
                                <li v-for="(signals, index) in signalType" @click.stop="currenttab = index" :class="{'active' : currenttab === index}">{{ signals[0] }}</li>
                                <li class="allchecked">
                                    <label>
                                        <input class="allchecked_checkbox" type="checkbox" @click.stop="checkall" v-model="checked">
                                        <div class="allchecked_img"></div>
                                        <span>全选</span>
                                    </label>
                                </li>
                            </ul>

                            <template v-for="(signals, index) in signalType">
                                <ul v-show="currenttab === index">
                                    <li v-for="(item, index) in signals[1]" @click.stop="selectSignalItem(item)" :class="marketsignals.indexOf(item) > -1 ? 'active' : ''">{{ signalData[item] }}</li>
                                </ul>
                            </template>
                        </div>
                    </div>
                    <div class="signalbox">
                        <div class="market_signal" v-for="item in marketsignals">
                            <p>{{ signalData[item] }}</p>
                            <span @click.stop="cancelSignalItem(item)"></span>
                        </div>
                    </div>
                    <div class="buttonbox">
                        <div class="finish" v-show="isfinishshow">
                            <p>回测运行完成 !</p>
                        </div>
                        <div class="savebacktest" @click.stop="save" v-show="isfinishshow">{{ isPublish === 1 ? '已发布' : '保存发布' }}</div>
                        <div v-if="!defaultqueryLoading" class="beginbacktest" @click.stop="startBacktest">{{ isfinishshow ? '再次回测' : '开始回测'}}</div>
                    </div>
                </div>
                <div class="question_analysis" v-show="backtestCompleted">
                    <p class="fl">系统对您语句解析后，以下列条件进行回测</p>
                    <div class="condition" :title="condi" v-for="condi in conditionData">{{ condi }}</div>
                </div>
            </div>
        </div>

        <template v-if="backtestCompleted">
            <report-grade
                :transactiontype="currentBacktestType"
                :signal-data="signalData"
                :report-data="reportData"
                :query="sentence">
            </report-grade>

            <backtest-analysis
                :transactiontype="currentBacktestType"
                :signal-data="signalData"
                :backtest-data="backtestAnalysisData"
                :max-winrate="reportData.maxWinRate"
                :max-annualyield="reportData.maxAnnualYield">
            </backtest-analysis>

            <strategy-select
                :show-pick="true"
                :transactiontype="currentBacktestType"
                :buy-position="parseInt(buyPosition)"
                :select-data="pickData"
                :query="sentence"
                :hold="dayBuyStockNum">
            </strategy-select>

            <profit-chart
                :backtest-id="id"
                :profit-data="profitData"
                :transactiontype="currentBacktestType"
                :max-winrate="reportData.maxWinRate"
                :max-annualyield="reportData.maxAnnualYield"
                :day-select="dayselect"
                :market-signals="bestMarketsignals"
                :signal-data="signalData"
                :hs-data="Hq300Data"
                :score-data="scoreData"
                :refresh="refresh">
            </profit-chart>

            <change-rate-group
                :backtest-id="id"
                :profit-group-data="profitGroupData"
                :transactiontype="currentBacktestType"
                :max-winrate="reportData.maxWinRate"
                :day-select="dayselect"
                :market-signals="bestMarketsignals"
                :signal-data="signalData"
                :refresh="refresh">
            </change-rate-group>

            <history-detail
                :backtest-id="id"
                :transactiontype="currentBacktestType"
                :max-winrate="reportData.maxWinRate"
                :day-select="dayselect"
                :market-signals="bestMarketsignals"
                :signal-data="signalData"
                :min-date="tradeStartDate"
                :max-date="tradeEndDate"
                :my-bar-option="myBarOption"
                :refresh="refresh">
            </history-detail>

        </template>

        <release-dialog :visible.sync="isreleaseshow" :is-publish.sync="isPublish" :backtest-id="id"></release-dialog>

        <div class="testmain" v-show="isshowtestloading">
            <div class="testshadow"></div>
            <div class="testparallel">
                <div class="test-loading">
                    <span class="testing-icon"></span>
                    <span>正在为您计算，请耐心等待……</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import changeRateGroup from './chart'
    import historyDetail from './history'
    import releaseDialog from './release-dialog'
    import backtestAnalysis from './backtest-analysis'
    import strategySelect from './strategy-select'
    import profitChart from './profit-chart'
    import reportGrade from './report-grade'
    import {showTradeDateDialog} from '@/lib/wDatePicker.js'
    import backtestBase from './../backtest/backtest-base'
    import { debounce } from 'lodash'

    export default {
        name: 'strategybacktest',
        mixins: [backtestBase],
        components: {
            'change-rate-group': changeRateGroup,
            'history-detail': historyDetail,
            'release-dialog': releaseDialog,
            'backtest-analysis': backtestAnalysis,
            'strategy-select': strategySelect,
            'profit-chart': profitChart,
            'report-grade': reportGrade
        },
        data () {
            var yesDate = this._getNowDate()
            var self = this
            var debounceQuestion = debounce(function () {
                self.questionDataValidation(arguments[0], arguments[1])
            }, 500)
            return {
                debounceQuestion,
                myBarOption: {
                    // barColor: '#f60', // 滚动条颜色
                    barWidth: 9, // 滚动条宽度
                    // railColor: '#f5f5f5', // 导航颜色
                    barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                    // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                    // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                    // zIndex: 'auto', // 滚动条的z-index
                    // autohidemode: true, // 自动隐藏模式
                    horizrailenabled: false // 是否显示水平滚动条
                },
                id: '',
                isfinishshow: false,
                isshadowshow: false,
                isreleaseshow: false,
                backtestCompleted: false,
                isshowtestloading: false,
                checked: false,
                isPublish: 0,

                defaultQuery: {},
                defaultqueryLoading: true,
                sentence: '',
                number: '',
                capital: '100000',
                stockHold: '1',
                dayBuyStockNum: '1',
                upperIncome: '',
                lowerIncome: '',
                fallIncome: '',
                bearMarketUpperIncome: '',
                bearMarketLowerIncome: '',
                bearMarketFallIncome: '',
                transactiontype: '1',
                currentBacktestType: '1',
                buyPosition: 0,
                tradeStartDate: '',
                tradeEndDate: '',
                yesterdayDate: yesDate,
                conditionData: [],
                reportData: {},
                scoreData: {},
                backtestData: [],
                profitGroupData: null,
                profitData: null,
                Hq300Data: [],
                pickData: null,
                currenttab: 'MACD',
                ismarketshow: false,
                signalType: {},
                signalData: {},
                marketsignals: [],
                engine: 'online',
                refresh: false,
                sharesselect: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                buyPositionSelect: [ '空仓', '10%仓位', '20%仓位', '30%仓位', '40%仓位', '50%仓位', '60%仓位', '70%仓位', '80%仓位', '90%仓位', '满仓' ],
                paramKeys: {
                    'query': 'sentence',
                    'daysForSaleStrategy': 'number',
                    'endDate': 'tradeEndDate',
                    'startDate': 'tradeStartDate',
                    'stockHoldCount': 'stockHold',
                    'upperIncome': 'upperIncome',
                    'lowerIncome': 'lowerIncome',
                    'fallIncome': 'fallIncome',
                    'dayBuyStockNum': 'dayBuyStockNum',
                    'capital': 'capital'
                }
            }
        },
        computed: {
            userId () {
                return this.$store.getters['userInfo/userId']
            },
            buriedPoint () {
                return this.$buriedPoint.strategyBacktest
            },
            totalPoint () {
                return this.$buriedPoint.totalPlatformAccess
            },
            dayselect: function () {
                return this.number.split(',')
            },
            // 取最优的两条
            backtestAnalysisData () {
                if (this.currentBacktestType === '1') {
                    return this.backtestData
                } else {
                    var maxWinRate = this.reportData.maxWinRate
                    var maxAnnualYield = this.reportData.maxAnnualYield

                    let analysisData = {}
                    analysisData[maxWinRate[1]] = this.backtestData[maxWinRate[1]]
                    analysisData[maxAnnualYield[1]] = this.backtestData[maxAnnualYield[1]]
                    return analysisData
                }
            },
            // 取最优的两条
            bestMarketsignals () {
                if (this.currentBacktestType === '1') {
                    return this.marketsignals
                } else {
                    var maxWinRate = this.reportData.maxWinRate
                    var maxAnnualYield = this.reportData.maxAnnualYield
                    if (maxWinRate[1] === maxAnnualYield[1]) {
                        return [maxWinRate[1]]
                    } else {
                        return [maxWinRate[1], maxAnnualYield[1]]
                    }
                }
            }
        },
        methods: {
            validateInput () {
                this.number = this.number.replace(/，/, ',')
            },
            qusetionCycle () {
                window.TA.log(this.buriedPoint.strategyParam.holdingCycle)
            },
            startDatePoint () {
                window.TA.log(this.buriedPoint.strategyParam.startDate)
            },
            endDatePoint () {
                window.TA.log(this.buriedPoint.strategyParam.endDate)
            },
            sharesSelect () {
                if (parseInt(this.stockHold) < parseInt(this.dayBuyStockNum)) {
                    this.dayBuyStockNum = this.stockHold
                }
                window.TA.log(this.buriedPoint.strategyParam.holdingNumber)
            },
            commonModel () {
                window.TA.log(this.buriedPoint.strategyParam.commonRuleTrade)
            },
            marketModel () {
                window.TA.log(this.buriedPoint.strategyParam.marketTimingTrade)
            },
            commonTargetProfitRiseRapidly () {
                window.TA.log(this.buriedPoint.commonRuleTrade.targetProfit.riseRapidly)
            },
            commonTargetProfitFall () {
                window.TA.log(this.buriedPoint.commonRuleTrade.targetProfit.fall)
            },
            commonStopProfit () {
                window.TA.log(this.buriedPoint.commonRuleTrade.stopProfit)
            },
            marketStrongTargetProfitRiseRapidly () {
                window.TA.log(this.buriedPoint.marketTimingTrade.strong.targetProfit.riseRapidly)
            },
            marketStrongTargetProfitFall () {
                window.TA.log(this.buriedPoint.marketTimingTrade.strong.targetProfit.fall)
            },
            marketStrongStopProfit () {
                window.TA.log(this.buriedPoint.marketTimingTrade.strong.stopProfit)
            },
            marketWeakTargetProfitRiseRapidly () {
                window.TA.log(this.buriedPoint.marketTimingTrade.weak.targetProfit.riseRapidly)
            },
            marketWeakTargetProfitFall () {
                window.TA.log(this.buriedPoint.marketTimingTrade.weak.targetProfit.fall)
            },
            marketWeakStopProfit () {
                window.TA.log(this.buriedPoint.marketTimingTrade.weak.stopProfit)
            },
            marketWeakPositionControl () {
                window.TA.log(this.buriedPoint.marketTimingTrade.weak.positionControl)
            },
            empty () {
                this.sentence = ''
                document.getElementById('question_sentence_input').focus()
            },
            questionDataValidation (event, num) {
                let val = event.target.value
                if (this.sentence.length > 200) {
                    this.sentence = val.substr(0, 200)
                }
                if (num === 0) {
                    window.TA.log(this.buriedPoint.strategyParam.modifyQuestion)
                } else {
                    if (this.filterKey.indexOf(event.keyCode) > -1) {
                        return
                    }
                    let self = this
                    let lastStr = this.sentence[this.sentence.length - 1]
                    if (this.chunkSeparator.indexOf(lastStr) > -1) { // chunk
                        axios.get('/chunk/search?query=' + this.sentence)
                        .then((res) => {
                            if (res) {
                                if (res.data.errorcode === 0) {
                                    self.searchVis = self.searchList.length !== 0
                                    let list = []
                                    res.data.result.forEach(item => {
                                        list.push(self.sentence + item)
                                    })
                                    self.searchList = list
                                    self.defaultSentence = self.sentence
                                } else {
                                    self.searchVis = false
                                }
                            }
                        }).catch((error) => {
                            self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                        })
                    } else {
                        axios.get('/chunk/searchdataextract?query=' + this.sentence)
                        .then((res) => {
                            if (res) {
                                if (res.data.errorcode === 0) {
                                    self.searchList = res.data.result
                                    self.searchVis = self.searchList.length !== 0
                                    self.defaultSentence = self.sentence
                                } else {
                                    self.searchVis = false
                                    self.searchList = []
                                }
                            }
                        }).catch((error) => {
                            self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                        })
                    }
                }
            },
            _getNowDate: function () {
                var now = new Date()
                now.setDate(now.getDate() - 1) // 获取昨天时间
                var month = now.getMonth() + 1
                month = month < 10 ? '0' + month : month
                var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
                var nowDate = now.getFullYear() + '-' + month + '-' + date
                return nowDate
            },
            showTradeDateDialog,
            save: function () {
                if (this.userId == null) {
                    // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
                    window.LoginInstance.show()
                    return
                }
                window.TA.log(this.buriedPoint.saveRelease)
                if (this.isPublish === 2) { // 已经保存
                    var self = this
                    this.$confirm({
                        'smallTitle': '该策略已保存',
                        'title': '您确定要发布该策略吗？',
                        'okBtnTitle': '确定',
                        'cancelBtnCallback': function (done) {
                            // window.TA.log(self.buriedPoint.saveAfterRelease.cancel)
                            done()
                        },
                        'okBtnCallback': function (done) {
                            var requestData = {id: self.id, is_publish: 1}
                            // window.TA.log(self.buriedPoint.saveAfterRelease.ok)
                            axios.post('/tradebacktest/save', requestData).then((res) => {
                                var response = res.data
                                done()
                                if (response.errorcode !== 0) {
                                    if (response.errorcode === -99) {
                                        self.$tip({message: '发布失败，您的同花顺账户暂未绑定手机号码', duration: 2000, type: 'error'})
                                        return
                                    }
                                    self.$tip({message: response.errormsg ? response.errormsg : '操作失败', duration: 2000, type: 'error'})
                                } else {
                                    self.$store.dispatch('myStrategy/requestTradeBacktest')
                                    self.$tip({message: '提交成功！正在审核中', duration: 2000, type: 'success'})
                                    self.isPublish = 1
                                }
                            }).catch(function (error) {
                                done()
                                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                            })
                        }
                    })
                } else if (this.isPublish !== 1) { // 未发布
                    this.isreleaseshow = true
                } else {}
            },
            moresignal: function () {
                window.TA.log(this.buriedPoint.timingSignal.openPanel)
                this.ismarketshow = false
                this.isshadowshow = !this.isshadowshow
            },
            closemoresignal: function () {
                this.isshadowshow = false
            },
            cancelSignalItem (item) {
                window.TA.log(this.buriedPoint.timingSignal.deleteSignal)
                this.marketsignals.splice(this.marketsignals.indexOf(item), 1)
            },
            selectSignalItem (item) {
                window.TA.log(this.buriedPoint.timingSignal.selectSignal)
                if (this.marketsignals.indexOf(item) < 0) {
                    this.ismarketshow = false
                    this.marketsignals.push(item)
                }
            },
            checkall () {
                window.TA.log(this.buriedPoint.timingSignal.selectAll)
                this.checked = !this.checked
                this.isshadowshow = true
                if (this.checked === true) {
                    for (var key in this.signalType) {
                        for (var index in this.signalType[key][1]) {
                            if (this.marketsignals.indexOf(this.signalType[key][1][index]) < 0) {
                                this.marketsignals.push(this.signalType[key][1][index])
                            }
                        }
                    }
                } else {
                    this.marketsignals = []
                }
            },
            sortNumber (a, b) {
                return a - b
            },
            startBacktest: function () {
                if (this.searchVis) {
                    this.searchVis = false
                    return
                }
                var self = this
                this.$nextTick(() => {
                    if (this.transactiontype === '1') {
                        if (!this.$refs.question_sentence_input.validate() ||
                            !this.$refs.question_cycle_input.validate() ||
                            !this.$refs.capital_input.validate() ||
                            !this.$refs.upper_income.validate() ||
                            !this.$refs.fall_income.validate() ||
                            !this.$refs.lower_income.validate()) {
                            return
                        }

                        window.TA.log(this.buriedPoint.strategyParam.startUpBacktest)

                        self.isshowtestloading = true
                        let numberArry = Array.from(new Set(self.number.split(',').sort(this.sortNumber)))
                        self.number = numberArry.join(',')
                        axios.post('/tradebacktest/yieldbacktest', {
                            query: self.sentence,
                            period: self.number,
                            start_date: self.tradeStartDate,
                            end_date: self.tradeEndDate,
                            stock_hold: self.stockHold,
                            upper_income: self.upperIncome,
                            lower_income: self.lowerIncome,
                            fall_income: self.fallIncome,
                            day_buy_stock_num: self.dayBuyStockNum,
                            engine: self.engine,
                            capital: self.capital
                        }).then((res) => {
                            if (res.data.errorcode !== 0) {
                                throw new Error(res.data.errormsg)
                            }
                            self.isfinishshow = true
                            self.isshowtestloading = false
                            self.isPublish = res.data.result.isSaved

                            self.id = res.data.result.id
                            if (self.id === res.data.result.id) {
                                self.refresh = !self.refresh
                            }
                            self.conditionData = res.data.result.conditionData
                            self.reportData = res.data.result.reportData
                            self.scoreData = res.data.result.scoreData
                            self.backtestData = res.data.result.backtestData
                            self.profitGroupData = res.data.result.profitGroupData
                            self.profitData = res.data.result.profitData
                            self.Hq300Data = res.data.result.Hq300Data
                            self.pickData = res.data.result.pickData

                            self.backtestCompleted = true
                            self.currentBacktestType = '1'

                            location.hash = '#/strategybacktest?query=' + encodeURIComponent(self.sentence) + '&daysForSaleStrategy=' + this.number + '&startDate=' + this.tradeStartDate + '&endDate=' + this.tradeEndDate + '&stockHoldCount=' + this.stockHold + '&dayBuyStockNum=' + this.dayBuyStockNum + '&upperIncome=' + this.upperIncome + '&lowerIncome=' + this.lowerIncome + '&fallIncome=' + this.fallIncome + '&engine=' + self.engine + '&capital=' + self.capital
                        }).then(() => {
                        }).catch((error) => {
                            self.isshowtestloading = false
                            self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                        })
                    } else {
                        if (!this.$refs.question_sentence_input.validate() ||
                            !this.$refs.question_cycle_input_1.validate() ||
                            !this.$refs.capital_input_1.validate() ||
                            !this.$refs.upper_income_1.validate() ||
                            !this.$refs.fall_income_1.validate() ||
                            !this.$refs.lower_income_1.validate() ||
                            !this.$refs.bear_market_upper_income.validate() ||
                            !this.$refs.bear_market_fall_income.validate() ||
                            !this.$refs.bear_market_lower_income.validate()) {
                            return
                        }
                        window.TA.log(this.buriedPoint.strategyParam.startUpBacktest)
                        if (self.marketsignals.length === 0) {
                            self.ismarketshow = true
                        } else {
                            self.isshowtestloading = true
                            self.isshadowshow = false
                            let numberArry = Array.from(new Set(self.number.split(',').sort(this.sortNumber)))
                            self.number = numberArry.join(',')
                            axios.post('/tradebacktest/mebacktest', {
                                query: self.sentence,
                                period: self.number,
                                start_date: self.tradeStartDate,
                                end_date: self.tradeEndDate,
                                stock_hold: self.stockHold,
                                day_buy_stock_num: self.dayBuyStockNum,
                                upper_income: self.upperIncome,
                                lower_income: self.lowerIncome,
                                fall_income: self.fallIncome,
                                bear_market_upper_income: self.bearMarketUpperIncome, // 弱势市场
                                bear_market_lower_income: self.bearMarketLowerIncome, // 弱势市场
                                bear_market_fall_income: self.bearMarketFallIncome, // 弱势市场
                                buy_position: self.buyPosition,
                                menv: self.marketsignals.join(','),
                                capital: self.capital
                            }).then((res) => {
                                if (res.data.errorcode !== 0) {
                                    throw new Error(res.data.errormsg)
                                }
                                self.isfinishshow = true
                                self.isshowtestloading = false
                                self.isPublish = res.data.result.isSaved

                                self.id = res.data.result.id
                                if (self.id === res.data.result.id) {
                                    self.refresh = !self.refresh
                                }
                                self.conditionData = res.data.result.conditionData
                                self.reportData = res.data.result.reportData
                                self.scoreData = res.data.result.scoreData
                                self.backtestData = res.data.result.backtestData
                                self.profitGroupData = res.data.result.profitGroupData
                                self.profitData = res.data.result.profitData
                                self.Hq300Data = res.data.result.Hq300Data
                                self.pickData = res.data.result.pickData

                                self.backtestCompleted = true
                                self.currentBacktestType = '2'

                                location.hash = '#/strategybacktest?query=' + encodeURIComponent(self.sentence) + '&daysForSaleStrategy=' + this.number + '&startDate=' + this.tradeStartDate + '&endDate=' + this.tradeEndDate + '&stockHoldCount=' + this.stockHold + '&dayBuyStockNum=' + this.dayBuyStockNum + '&upperIncome=' + this.upperIncome + '&lowerIncome=' + this.lowerIncome + '&fallIncome=' + this.fallIncome + '&bearMarketUpperIncome=' + this.bearMarketUpperIncome + '&bearMarketLowerIncome=' + this.bearMarketLowerIncome + '&bearMarketFallIncome=' + this.bearMarketFallIncome + '&buyPosition=' + this.buyPosition + '&menv=' + this.marketsignals.join(',') + '&capital=' + self.capital
                            }).then(() => {
                            }).catch((error) => {
                                self.isshowtestloading = false
                                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                            })
                        }
                    }
                })
            },
            startBacktestByRoute (routeParam) {
                var self = this
                var hasChanged = false
                for (let key in this.paramKeys) {
                    if (routeParam.hasOwnProperty(key) && routeParam[key] !== '' && self[self.paramKeys[key]] !== routeParam[key]) {
                        self[self.paramKeys[key]] = routeParam[key]
                        hasChanged = true
                    }
                }

                if ('stockHoldCount' in routeParam && !('dayBuyStockNum' in routeParam)) {
                    self.dayBuyStockNum = routeParam.stockHoldCount
                }

                var bearMarketUpperIncome = routeParam.hasOwnProperty('bearMarketUpperIncome') ? routeParam.bearMarketUpperIncome : self.upperIncome
                var bearMarketLowerIncome = routeParam.hasOwnProperty('bearMarketLowerIncome') ? routeParam.bearMarketLowerIncome : self.lowerIncome
                var bearMarketFallIncome = routeParam.hasOwnProperty('bearMarketFallIncome') ? routeParam.bearMarketFallIncome : self.fallIncome

                if (routeParam.hasOwnProperty('menv') && routeParam['menv'] !== '') {
                    if (self.currentBacktestType === '1') {
                        hasChanged = true
                    }
                    self.transactiontype = '2'
                    self.marketsignals = routeParam['menv'].split(',')

                    // 择时 熊市参数
                    if (bearMarketUpperIncome !== self.bearMarketUpperIncome ||
                        bearMarketLowerIncome !== self.bearMarketLowerIncome ||
                        bearMarketFallIncome !== self.bearMarketFallIncome) {
                        hasChanged = true
                    }
                    if (routeParam.hasOwnProperty('buyPosition') && self['buyPosition'] !== routeParam['buyPosition']) {
                        self['buyPosition'] = routeParam['buyPosition']
                        hasChanged = true
                    }
                } else {
                    if (self.currentBacktestType === '2') {
                        hasChanged = true
                    }
                    self.transactiontype = '1'
                }

                if (['stable', 'online'].indexOf(routeParam.engine)) {
                    self.engine = routeParam.engine
                }

                self.bearMarketUpperIncome = bearMarketUpperIncome
                self.bearMarketLowerIncome = bearMarketLowerIncome
                self.bearMarketFallIncome = bearMarketFallIncome
                if (!self.backtestCompleted || hasChanged) {
                    this.startBacktest()
                }
            },
            initParams () {
                this.capital = '100000'
                if (this.defaultQuery) {
                    this.sentence = this.defaultQuery.query
                    this.tradeStartDate = this.defaultQuery.startDate
                    this.tradeEndDate = this.defaultQuery.endDate
                    this.number = this.defaultQuery.daysForSaleStrategy
                    this.stockHold = this.defaultQuery.stockHoldCount
                    this.dayBuyStockNum = !('dayBuyStockNum' in this.defaultQuery) ? this.stockHold : this.defaultQuery.dayBuyStockNum
                    this.upperIncome = this.defaultQuery.upperIncome
                    this.lowerIncome = this.defaultQuery.lowerIncome
                    this.fallIncome = this.defaultQuery.fallIncome

                    this.bearMarketUpperIncome = this.defaultQuery.upperIncome
                    this.bearMarketLowerIncome = this.defaultQuery.lowerIncome
                    this.bearMarketFallIncome = this.defaultQuery.fallIncome
                } else {
                    this.sentence = ''
                    this.tradeStartDate = ''
                    this.tradeEndDate = ''
                    this.number = ''
                    this.stockHold = '1'
                    this.dayBuyStockNum = '1'
                    this.upperIncome = ''
                    this.lowerIncome = ''
                    this.fallIncome = ''
                    this.bearMarketUpperIncome = ''
                    this.bearMarketLowerIncome = ''
                    this.bearMarketFallIncome = ''
                }
            // },
            // __scrollBar__ () {
            //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
            //         window.TA.log(this.buriedPoint.scrollBar)
            //     }
            }
        },
        watch: {
            marketsignals () {
                if (this.marketsignals.length !== 20) {
                    this.checked = false
                } else {
                    this.checked = true
                }
            },
            '$route' (newRoute, oldRoute) {
                if (this.defaultqueryLoading) {
                    return
                }

                if (newRoute.name === 'strategybacktest') {
                    let params = newRoute.query
                    if (newRoute.name === oldRoute.name) {
                        this.startBacktestByRoute(params)
                    } else {
                        if (JSON.stringify(params) !== '{}') {
                            this.startBacktestByRoute(params)
                        }
                    }
                }
            }
        },
        // beforeDestroy () {
        //     window.removeEventListener('scroll', this.__scrollBar__)
        // },
        activated () {
            var self = this
            // window.addEventListener('scroll', self.__scrollBar__)
            window.TA.log({id: self.buriedPoint.pageAccess, _sid: '__ths_001'})
            window.TA.log({id: self.totalPoint, _sid: '__ths_002'})
        },
        deactivated () {
            // 重置初始化状态
            this.initParams()
            this.id = ''
            this.isfinishshow = false
            this.isshadowshow = false
            this.isreleaseshow = false
            this.backtestCompleted = false
            this.isshowtestloading = false
            this.checked = false
            this.isPublish = 0
            this.transactiontype = '1'
            this.currentBacktestType = '1'
            this.buyPosition = 0
            this.conditionData = []
            this.reportData = {}
            this.scoreData = {}
            this.backtestData = []
            this.Hq300Data = []
            this.pickData = null
            this.currenttab = 'MACD'
            this.ismarketshow = false
            this.marketsignals = []

            this.$refs.question_sentence_input.className = 'question_sentence_input'
            this.$refs.question_cycle_input.className = 'question_cycle_input'
            this.$refs.upper_income.className = ''
            this.$refs.fall_income.className = ''
            this.$refs.lower_income.className = ''
            this.$refs.question_cycle_input_1.className = 'question_cycle_input'
            this.$refs.upper_income_1.className = ''
            this.$refs.fall_income_1.className = ''
            this.$refs.lower_income_1.className = ''
            this.$refs.bear_market_upper_income.className = ''
            this.$refs.bear_market_fall_income.className = ''
            this.$refs.bear_market_lower_income.className = ''
            this.$refs.sentenceNotice.style.display = 'none'
            this.$refs.profitlossNotice.style.display = 'none'
            this.$refs.numberNotice.style.display = 'none'
        },
        mounted () {
            var self = this
            this.defaultqueryLoading = true
            axios.get('/backtestonce/defaultquery?type=1').then((res) => {
                self.defaultqueryLoading = false
                if (res.data.result) {
                    self.defaultQuery = res.data.result
                    self.initParams()
                }
                if (JSON.stringify(self.$route.query) !== '{}') {
                    self.startBacktestByRoute(self.$route.query)
                }
            }).catch(function (error) {
                self.defaultqueryLoading = false
                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
            })

            axios.get('/tradebacktest/menvdata').then((res) => {
                this.signalType = res.data.result.type
                this.signalData = res.data.result.data
            }).catch(function (error) {
                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategybacktest/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategybacktest/index.vue